import { Fragment, useState } from 'react';
import ContentLoader from 'react-content-loader';
import Container from '../../../../../core/components/atoms/Container';
import ExamItem from '../../../../../core/components/molecules/Exam/Item';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { ResponsiveMarketingBanners } from '../../../../../core/components/organism/ResponsiveMarketingBanner';
import { usePracticeEnemListHook } from '../../../hooks/Enem/list';
import { Button } from '../../../../../core/components/atoms/Button';
import { MODAL_VIDEOS_VIMEO_ALLOWED } from '../../../../../core/constants/modal-videos';
import { SimuladoInfoModal } from '../../../components/SimuladoInfoModal';

const PracticeEnemList = () => {
  const [isSimuladoInfoModalOpen, setIsSimuladoInfoModalOpen] = useState(false);
  const {
    years,
    practiceEnemList,
    isLoading,
    getLastAttemptDate,
    getPracticeStatus,
    getDaysLabel,
    getDisplayedAttempt,
    getCorrectAnswersPercentual,
    handlePracticeAction,
  } = usePracticeEnemListHook();

  if (isLoading) {
    return (
      <Container>
        <Fragment>
          {Array.from({ length: 10 }, (_, index) => (
            <ContentLoader
              key={index}
              backgroundColor={'#a7adba'}
              foregroundColor={'#c0c5ce'}
              viewBox='0 0 500 35'
            >
              <rect x='0' y='10' rx='2' ry='2' width='300' height='13' />
              <rect x='0' y='25' rx='2' ry='2' width='250' height='10' />
            </ContentLoader>
          ))}
        </Fragment>
      </Container>
    );
  }

  return (
    <Container>
      <div className='flex flex-col justify-between md:flex-row md:items-center'>
        <Typography type='title' size='h1' className='pt-5'>
          Simuladão Enem
        </Typography>
        {MODAL_VIDEOS_VIMEO_ALLOWED.SIMULADO_ENEM.allowed && (
          <Button
            variant='text'
            LeftIcon='info'
            iconType='material'
            iconSize='small'
            className='p-0 text-md md:text-md'
            onClick={() => setIsSimuladoInfoModalOpen(true)}
          >
            Como funciona
          </Button>
        )}
      </div>
      <SimuladoInfoModal
        isOpen={isSimuladoInfoModalOpen}
        onClose={() => setIsSimuladoInfoModalOpen(false)}
      />

      <ResponsiveMarketingBanners className='mt-8' />

      {years.map((year) => (
        <div className='flex flex-col gap-sm pt-6' key={`year${year}`}>
          <Typography type='titleSection'>{year}</Typography>

          <ul className='flex flex-col gap-lg'>
            {practiceEnemList[parseInt(year)].map((practice) => {
              return (
                <ExamItem
                  key={`practice${practice.id}`}
                  title={practice.name}
                  status={getPracticeStatus(practice)}
                  correctAnswersPercentual={getCorrectAnswersPercentual(
                    practice
                  )}
                  totalQuestions={practice.totalQuestions}
                  lastAttemptDate={getLastAttemptDate(practice)}
                  daysLabel={getDaysLabel(practice)}
                  onButtonClick={(action) =>
                    handlePracticeAction(practice, action)
                  }
                  answers={getDisplayedAttempt(practice) ?? undefined}
                />
              );
            })}
          </ul>
        </div>
      ))}
    </Container>
  );
};
export default PracticeEnemList;
